import httpRequest from './http'
export default {
  // 微信登录
  postAwardWechat: a => httpRequest.post('https://www.cnorch.com/client2/web/award/awardWechat', a),

  // token微信登录信息
  getWxMpUser: t => httpRequest.get('https://www.cnorch.com/client2/wxLogin/wxMpUser', t),

  // 通知列表
  getNoticeList: () => httpRequest.get('https://www.cnorch.com/client2/web/basic/noticeList'),

  // 资讯列表
  getNewsList: n => httpRequest.get('https://www.cnorch.com/client2/web/basic/newsList', n),

  // 省站资讯列表
  getProvinceNewsList: n => httpRequest.get('https://www.cnorch.com/client2/web/basic/provinceNewsList', n),

  // 资讯详情
  getNewsInfo: (n, id) => httpRequest.get('https://www.cnorch.com/client2/web/basic/provinceNewsInfo?id=' + id, n),

  // 省站资讯详情
  getProvinceNewsInfo: (n, id) => httpRequest.get('https://www.cnorch.com/client2/web/basic/newsInfo?id=' + id, n),

  // 活动列表
  postActivityList: a => httpRequest.post('https://www.cnorch.com/client2/web/basic/activityList', a),

  // 活动详情
  getActivityInfo: a => httpRequest.get('https://www.cnorch.com/client2/web/basic/activityInfo', a),

  // 城市列表
  getAreaList: () => httpRequest.get('https://www.cnorch.com/client2/web/musician/areaList'),

  // 省份列表
  getProvList: () => httpRequest.get('https://www.cnorch.com/client2/web/basic/provList'),

  // 乐队列表
  postBrandList: b => httpRequest.post('https://www.cnorch.com/client2/web/musician/brandList', b),

  //乐队详情
  getBrandInfo: b => httpRequest.get('https://www.cnorch.com/client2/web/musician/brandInfo', b),

  // 专家列表
  postMusicianList: m => httpRequest.post('https://www.cnorch.com/client2/web/musician/musicianList', m),

  // 专业列表
  getSpecialityList: () => httpRequest.get('https://www.cnorch.com/client2/web/musician/specialityList'),

  // 星光列表
  postAwardList: a => httpRequest.post('https://www.cnorch.com/client2/web/award/awardList', a),

  // 星光详情
  getAwardInfo: a => httpRequest.get('https://www.cnorch.com/client2/web/award/awardInfo', a),

  // 星光点赞
  postAwardWechat: a => httpRequest.post('https://www.cnorch.com/client2/web/award/awardWechat', a),

  // 类型列表
  getTypeList: t => httpRequest.get('https://www.cnorch.com/client2/web/music/typeList', t),

  // 乐谱汇
  postMusicScoreList: m => httpRequest.post('https://www.cnorch.com/client2/web/music/musicScoreList', m),

  // 知识汇分类列表
  getKnowledgeTypeList: k => httpRequest.get('https://www.cnorch.com/client2/web/knowledge/typeList', k),

  // 知识汇列表
  postKnowledgeList: k => httpRequest.post('https://www.cnorch.com/client2/web/knowledge/knowledgeList', k),

  // 省站列表
  getSzList: s => httpRequest.get('https://www.cnorch.com/client2/web/basic/szList', s),

  // 音乐欣赏
  postMusicEnjoyList: m => httpRequest.post('https://www.cnorch.com/client2/web/music/musicEnjoyList', m),

  //师资认证列表/web/basic/teacherList
  postTeacherList: te => httpRequest.post('https://www.cnorch.com/client2/web/basic/teacherList', te),

  //人才招募/web/basic/recruitList
  postrecruitList: r => httpRequest.post('https://www.cnorch.com/client2/web/basic/recruitList', r),

  //新闻点击次数/web/basic/clickNews
  getOnclick: (num) => httpRequest.get('https://www.cnorch.com/client2/web/basic/clickNews', num),

  //活动点击次数/web/basic/clickActivity
  getActiveClick: (num) => httpRequest.get('https://www.cnorch.com/client2/web/basic/clickActivity', num),

  //乐谱点击/web/music/clickMusicScore
  getMusicClick: (num) => httpRequest.get("https://www.cnorch.com/client2/web/music/clickMusicScore", num),

  //知识库点击/web/knowledge/clickKnowledge
  getKnowledgeClick: (num) => httpRequest.get('https://www.cnorch.com/client2/web/knowledge/clickKnowledge', num),
  //  bannerList 列表
  bannerList:(num)=>httpRequest.get('https://www.cnorch.com/client2/web/basic/bannerList',num)

}



// WEBPACK FOOTER //
// ./src/request/api.js